import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { AuthorizationService } from './authorization.service';
import { Permission } from './permission';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[hasPermission]',
  standalone: true
})
export class HasPermissionDirective implements OnDestroy {
  private permission?: Permission;
  private sub?: Subscription;

  constructor(
    private auth: AuthorizationService,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef
  ) {
    this.sub = this.auth.roles$.subscribe(() => this.updateView());
  }

  @Input()
  set hasPermission(permission: Permission) {
    this.permission = permission;
    this.updateView();
  }

  private updateView() {
    if (!this.permission) return;

    this.viewContainer.clear(); // ✅ Immer zuerst leeren

    if (this.auth.hasPermission(this.permission)) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }
}
